export default __webpack_public_path__ + "static/media/mint.cf17e853.svg";